import { AxiosInstance } from "axios";
import { ModelClient } from "../ModelClient";
import { RestrictedUserEntity } from "../../domain/entities/RestrictedUser";

export class RestrictedUserClient extends ModelClient<RestrictedUserEntity> {

  constructor(apiClient: AxiosInstance) {
    super(apiClient, 'RestrictedUser')
  }
}